import { render } from "./FormTrainingRegionAnchorItem.vue?vue&type=template&id=096aefa9&scoped=true&ts=true"
import script from "./FormTrainingRegionAnchorItem.vue?vue&type=script&lang=ts"
export * from "./FormTrainingRegionAnchorItem.vue?vue&type=script&lang=ts"

import "./FormTrainingRegionAnchorItem.vue?vue&type=style&index=0&id=096aefa9&scoped=true&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-096aefa9"]])

export default __exports__